import React from "react";
import Layout from "../../Components/Dashboard/Layout/Layout";
import StatementSection from "../../Components/Dashboard/Statement/StatementSection";

const Statement = () => {
  return (
    <>
      <Layout>
        <div
          className="dashboard__content hover-bgc-color"
          style={{ marginTop: "6%" }}
        >
          <StatementSection />
        </div>
      </Layout>
    </>
  );
};

export default Statement;
